@let coupon = coupon$ | async;
@let readOnly = readOnly$ | async;
@let segments = segments$ | async;
@let redemptions = redemptions$ | async;
@let categories = ticketCategories$ | async;

<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Informações do Cupom'"
    [titleIcon]="'pi pi-tag'"
    [subtitle]="'Confira os dados do seu cupom.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Detalhes do evento', link: '/producer-area/event/' + coupon?.event_id, icon: 'pi pi-calendar' },
      { label: 'Cupons de Desconto', icon: 'pi pi-tag' },
      { label: 'Detalhe', icon: 'pi pi-tag' },
    ]"></app-page-header>

  <div class="container-fluid coupon-detail">
    <div class="coupon-detail__top">
      <app-button icon="pi pi-chevron-left" styleType="primary" (btnClick)="goBack()">Voltar</app-button>
      @if (coupon) {
        <div class="coupon-detail__top-actions">
          <app-button
            styleType="outlined"
            icon="pi pi-file-pdf"
            [loading]="downloading()"
            (btnClick)="downloadReport(coupon)">
            Relatório PDF
          </app-button>
          @if (coupon.status === "active" && !readOnly) {
            <app-button styleType="danger" (btnClick)="closeCoupon(coupon)">Encerrar</app-button>
            <app-button styleType="primary" (btnClick)="editCoupon(coupon)">Editar</app-button>
          }
        </div>
      }
    </div>

    @if (coupon) {
      <section class="coupon-detail__card">
        <div class="coupon-detail__info">
          <dl class="coupon-detail__list">
            <div class="coupon-detail__row">
              <dt>Evento:</dt>
              <dd>{{ coupon.event?.title ?? "-" }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Código do Cupom:</dt>
              <dd>{{ coupon.code }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Descrição:</dt>
              <dd>{{ coupon.description ?? "-" }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Desconto:</dt>
              <dd>{{ coupon.discount_percentage }}%</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Ingressos / lotes do cupom:</dt>
              <dd>{{ categories?.length ? categories?.join(", ") : "-" }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Máx. de ingressos com desconto por uso:</dt>
              <dd>{{ coupon.max_discounted_items }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Quantidade:</dt>
              <dd>{{ coupon.quantity }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Utilizados:</dt>
              <dd>{{ coupon.used_count }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Criado em:</dt>
              <dd>{{ coupon.created_at | date: "dd/MM/yyyy - HH'h'mm" }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Expira em:</dt>
              <dd>{{ coupon.expires_at | date: "dd/MM/yyyy - HH'h'mm" }}</dd>
            </div>
            <div class="coupon-detail__row">
              <dt>Status:</dt>
              <dd>
                <span class="coupon-detail__status coupon-detail__status--{{ coupon.status }}">
                  {{ coupon.status_display }}
                </span>
              </dd>
            </div>
          </dl>
        </div>

        <div class="coupon-detail__chart">
          @if (segments) {
            <app-pie-chart
              canvasId="coupon-usage"
              [segments]="segments"
              [colors]="['#28a745', '#7c0084']"
              valueSuffix="%" />
          }
        </div>
      </section>

      <section class="coupon-detail__redemptions">
        <h3 class="coupon-detail__redemptions-title">Usuários que utilizaram o cupom</h3>

        @if (redemptions) {
          @if (redemptions.data.length) {
            <div class="coupon-detail__table">
              <p-table [value]="redemptions.data" [scrollable]="true" class="p-datatable-striped">
                <ng-template pTemplate="header">
                  <tr>
                    <th>NOME</th>
                    <th>E-MAIL</th>
                    <th>TELEFONE</th>
                    <th>DESCONTO</th>
                    <th>UTILIZADO EM</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-redemption>
                  <tr>
                    <td>{{ redemption.user_name ?? "-" }}</td>
                    <td>{{ redemption.user_email ?? "-" }}</td>
                    <td>{{ redemption.user_phone_number ?? "-" }}</td>
                    <td>{{ redemption.discount_amount | currency: "BRL" : "symbol" : "1.2-2" }}</td>
                    <td>{{ redemption.used_at | date: "dd/MM/yyyy - HH'h'mm" }}</td>
                  </tr>
                </ng-template>
              </p-table>

              <p-paginator
                (onPageChange)="handleRedemptionsPage($event)"
                [first]="first"
                [rows]="rows"
                [totalRecords]="redemptions.meta.total_count || 0"
                [showCurrentPageReport]="false"
                [showPageLinks]="false"
                [showJumpToPageDropdown]="false" />
            </div>
          } @else {
            <div class="coupon-detail__empty">
              <i class="pi pi-users"></i>
              <p>Nenhum usuário utilizou este cupom ainda.</p>
            </div>
          }
        } @else {
          <p-skeleton height="200px" />
        }
      </section>
    } @else {
      <p-skeleton height="400px" />
    }
  </div>
</app-layout>
